"use client";

import z from "zod";

import type { UseRequestQueryProps } from "../../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../../request/hooks/useRequestQuery";

export type UseRequestCommunitiesStripeConnectDashboardProps =
  UseRequestQueryProps & {
    id: number;
  };

export const useRequestCommunitiesStripeConnectDashboard = ({
  id,
  ...props
}: UseRequestCommunitiesStripeConnectDashboardProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      urlBackendPath: `/me/communities/${id}/stripe/dashboard`,
      method: "GET",
      schema: z.object({
        url: z.string(),
      }),
    },
  }),
});
